module.exports = __webpack_public_path__ + "img/08.80cf1b87.jpg";